import { Component, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent {
    constructor(
        private router: Router,
        translate: TranslateService,
        public toastr: ToastsManager, vRef: ViewContainerRef,
    ) {
        this.toastr.setRootViewContainerRef(vRef);
        router.events.subscribe((event) => {
            window.scrollTo(0, 0);
        });
        translate.addLangs(['en', 'de', 'it', 'fr']);
        // this language will be used as a fallback when a translation isn't found in the current language
        translate.setDefaultLang('en');

         // the lang to use, if the lang isn't available, it will use the current loader to get them
        // translate.use('en');
        const browserLang = translate.getBrowserLang();
        translate.use(browserLang.match(/en|de|it|fr/) ? browserLang : 'en');
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts